import styled from 'styled-components';

export const Groups = styled.div`
  background: white;
  min-height: 100%;
`
